import _ from 'lodash';
import store from '@/store';
const W3CWebSocket = require('websocket').w3cwebsocket;

const host = process.env.VUE_APP_SCANNER_HOST;
const port = process.env.VUE_APP_SCANNER_PORT;
const DEV_MODE = false;
// const DEV_MODE = process.env.NODE_ENV !== 'production';

interface EventWithData extends Event {
  data: any
}

class Scanner {
  failNative: boolean = false;
  keepAlive: boolean = false;
  opened: boolean = false;
  ws: WebSocket;

  constructor() {
    
  }

  public start() {
    this.keepAlive = true;
    this.initializeConnection();
  }
  
  public stop() {
    this.keepAlive = false;
    if (this.ws) {
      this.ws.close();
    }
  }

  private restart() {
    setTimeout(() => {
      if (!this.opened) {
        this.initializeConnection();
      }
    }, 5000);
  }

  private initializeConnection() {
    const url = "ws://" + host + ":" + port + "/";
    if (this.failNative) {
      this.ws = new W3CWebSocket(url);
    } else {
      this.ws = new WebSocket(url);
    }

    this.ws.onmessage = (event: EventWithData) => {
      this.onMessage(event)
    };
    this.ws.onopen = () => {
      this.onOpen();
    };
    this.ws.onclose = () => {
      this.onClose();
    };
    this.ws.onerror = (err) => {
      this.failNative = !this.failNative;
      if (DEV_MODE) {
        console.log(this.failNative);
        console.log(err);
      }
    };
    
  }

  private onMessage(event: EventWithData) {
    const data = JSON.parse(_.get(event, 'data', ''));
    if (DEV_MODE) console.log(data);
    store.dispatch('scannerInput', _.get(data, 'value', ''));
  }
  
  private onOpen() {
    if (DEV_MODE) console.log('Opened socket');
    store.dispatch('scannerConnected', true);
    this.opened = true;
  }

  private onClose() {
    if (DEV_MODE) console.log('Socket closed ' + (this.keepAlive ? 'unexpectedly' : 'consciously'));
    this.opened = false;
    if (this.keepAlive) {
      this.restart();
    } else {
      store.dispatch('scannerConnected', false);
    }
  }

}

const scanner = new Scanner();

export default scanner; 